import React, { useState, useEffect } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import useToken from 'hooks/useToken';

import SubscriptionTitle from './SubscriptionTitle';
import SubscriptionInfo from './SubscriptionInfo';
import SubscriptionProducts from './SubscriptionProducts';
import SubscriptionOrders from './SubscriptionOrders';
import SubscriptionLogs from './SubscriptionLogs';


const SubscriptionPage = () => {
    const { idSuscripcion } = useParams();
    const { token } = useToken();
    const [infoSuscripcion, setInfoSuscripcion] = useState(null);

    const ObtenerSuscripcionInfo = async () => {
        if (!idSuscripcion) return;

        try {
            const response = await fetch(`/api/Suscripciones/ObtenerSuscripcionInfo`, {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idSuscripcion: parseInt(idSuscripcion) })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const ObjDetalles = JSON.parse(data.detalles);
                    const detalles = ObjDetalles.table2 || [];
                    if (detalles.length > 0) {
                        setInfoSuscripcion(detalles[0]);
                    }
                }
            }
        } catch (error) {
            console.error("Error obteniendo info de suscripción", error);
        }
    };

    useEffect(() => {
        ObtenerSuscripcionInfo();
    }, [idSuscripcion]);

    return (
        <Container fluid>
            <Row>
                <Col xs={12}>
                    <SubscriptionTitle
                        idSuscripcion={idSuscripcion}
                        infoSuscripcion={infoSuscripcion}
                        onRefreshInfo={ObtenerSuscripcionInfo}
                    />
                </Col>

            </Row>

            <Row className="mt-4" >
                <Col xs={12} lg={4} className="mb-4 mb-lg-0">
                    <SubscriptionInfo
                        idSuscripcion={idSuscripcion}
                        info={infoSuscripcion}
                        onRefreshInfo={ObtenerSuscripcionInfo}
                    />
                </Col>
                <Col xs={12} lg={8}>
                    <SubscriptionProducts idSuscripcion={idSuscripcion} />
                </Col>
            </Row>

            <Row className="mt-4">
                <Col xs={12}>
                    <SubscriptionOrders idSuscripcion={idSuscripcion} />
                </Col>
            </Row>

            <Row className=" mb-4">
                <Col xs={12}>
                    <SubscriptionLogs idSuscripcion={idSuscripcion} />
                </Col>
            </Row>

        </Container>

    );

};

export default SubscriptionPage;